import React from "react";
import { XMLJSON } from "../../livedataFuncs"
import { createDateDayMonthYear, createDateToAMPMTimeNew, deleteNoteReply, lawyerInitialsFuncs } from "../fileToolbarFuncs";
import { Col, Row, Form, Dropdown, InputGroupProps } from "react-bootstrap";
import { AddNoteRepliesButton } from "./fileToolBarNoteComponent";
import { RightSideContext } from "../../Context/RightSideContext";
import { RightMenuEditTextArea } from "./filetoolbarNoteEdit";

interface IProps {
    index: number,
    reply: XMLJSON,
    parentIndex: number,
}

interface IState {
    initials: string,
    showEditBox: boolean,
}

export class NoteRightSideReplies extends React.Component<IProps, IState>{
    constructor(props) {
        super(props);
        let nameArr = props.reply.attributes.CreatedByUser.split(" ");
        let firstName = nameArr[0];
        let lastName = nameArr[1];
        let initialsOfReply = lawyerInitialsFuncs(firstName, lastName);
        this.state = {
            initials: initialsOfReply,
            showEditBox: false,
        }
    }

    setEditBoxState = (changeState: boolean) => {
        this.setState({ showEditBox: changeState });
    }

    render(): React.ReactNode {
        let timeOfCreate, daymonthyearCreate;
        
        let dateToUse = this.props.reply.attributes.LastModifiedDate?this.props.reply.attributes.LastModifiedDate:this.props.reply.attributes.CreateDate;
        if (dateToUse) {
            timeOfCreate = createDateToAMPMTimeNew(dateToUse);
            daymonthyearCreate = createDateDayMonthYear(dateToUse);
        }

        let lawyerFirstNameHolder, lawyerLastNameHolder;
        if (this.props.reply.attributes.DisplayName) {
            lawyerFirstNameHolder = this.props.reply.attributes.DisplayName.split(" ")[0];
            lawyerLastNameHolder = this.props.reply.attributes.DisplayName.split(" ")[1];
        } else {
            lawyerFirstNameHolder = this.props.reply.attributes.CreatedByUser.split(" ")[0];
            lawyerLastNameHolder = this.props.reply.attributes.CreatedByUser.split(" ")[1];
        }

        return (
            <div key={`reply-${this.props.index}`} className="note-reply">
                <Row className="gx-0">
                    <Col className="col-md-auto">
                        <i className="fa-solid fa-arrow-turn-down-left status-secondary" style={{transform: 'scaleX(-1)', marginRight:'5px'}}></i>
                    </Col>
                    <Col>
                        <h3>{lawyerFirstNameHolder} {lawyerLastNameHolder}</h3>
                        <Form.Label>
                            {daymonthyearCreate} {timeOfCreate}
                            {this.props.reply.attributes.Edited == '1' ? ' (edited)' : null}
                        </Form.Label>
                    </Col>
                    <Col md='auto'>
                        <RightSideContext.Consumer>
                            {
                                value =>
                                    <this.AddMenu index={this.props.index} CreatedByUser={this.props.reply.attributes.CreatedByUser} session={value.account} parentIndex={this.props.parentIndex}></this.AddMenu>
                            }
                        </RightSideContext.Consumer>
                    </Col>
                </Row>
                
                <Row>
                    <Col>
                        <div className="note-container">
                            {
                                this.state.showEditBox ?
                                    <>
                                        <RightMenuEditTextArea
                                            text={this.props.reply.attributes.text}
                                            setEditFlag={this.setEditBoxState}
                                            index={this.props.parentIndex}
                                            subIndex={this.props.index}
                                        />
                                    </>
                                    :
                                    <>
                                        <pre style={{margin: 0, background: 'none', border: 'none', fontFamily: 'inherit', fontSize: 'inherit', padding: 0, whiteSpace: 'pre-wrap'}}>
                                            {this.props.reply.attributes.text}
                                        </pre>
                                    </>
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
    /**
 * ... icon for dropdown
 */
    CustomToggle = React.forwardRef<HTMLInputElement, InputGroupProps>(
        ({ children, onClick }, ref) => (
            <i className={"fa-solid fa-ellipsis note-options"}
                ref={ref}
                onClick={(e) => {
                    e.preventDefault();
                    onClick(e);
                }}>
                {children}
            </i>
        ))

    AddMenu = (props: AddNoteRepliesButton) => {
        return (
            <>
                {props.CreatedByUser === props.session &&
                    <Dropdown>
                        <Dropdown.Toggle as={this.CustomToggle} />
                        <Dropdown.Menu>
                            <Dropdown.Item key={`main-note-edit-${props.index}`} onClick={() => {
                                this.setEditBoxState(true);
                            }
                            }>
                                Edit
                            </Dropdown.Item>

                            <Dropdown.Item key={`main-note-delete-${props.index}`} onClick={() => {
                                deleteNoteReply(props.parentIndex, props.index);
                                //delete reply
                            }
                            }>
                                Remove
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                }
            </>
        )
    }
}